export const generateAccountsURL = (
  token: string,
  citizenPortalHomeLinkURL: string,
  isAccountsEnabled: boolean
): string | null => {
  if (!isAccountsEnabled || !token || !citizenPortalHomeLinkURL) {
    return null;
  }

  const encodedLogoutRedirectUrl = encodeURIComponent(citizenPortalHomeLinkURL);

  return `${process.env.APP_HOST_URL}/private-submission/create?crm_token=${token}&logout_redirect_url=${encodedLogoutRedirectUrl}`;
};

export const getAccountsEnabledStatus = (
  crmAuthentication?: IAgencyCRMAuthResponse,
  integrations?: IIntegrationResponse
): boolean => {
  return crmAuthentication?.citizenAuth0?.isActive || integrations?.citizenAuth0?.isActive || false;
};
